import { ReactComponent as BudgetIcon } from "../../../assets/icons/gestione_budget.svg";
import { useTheme } from "@mui/material";

const IconBudget: React.FC = (props) => {
  const theme = useTheme();

  return (
    <BudgetIcon
      width="24px"
      height="24px"
      style={{
        padding: "2px",
        fill: theme.palette.text.primary,
      }}
    />
  );
};

export default IconBudget;
